import { render, staticRenderFns } from "./StepsNavigation.vue?vue&type=template&id=836e6dba&scoped=true"
import script from "./StepsNavigation.vue?vue&type=script&lang=ts"
export * from "./StepsNavigation.vue?vue&type=script&lang=ts"
import style0 from "./StepsNavigation.vue?vue&type=style&index=0&id=836e6dba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836e6dba",
  null
  
)

export default component.exports